export default {
  seekBtn(type) {
    // type 1 救助服务 2 健康体检 3 认知筛选 4 法律咨询
    const pages = {
      1: "/healthManager/list?aType=8&aTitle=非医疗紧急转运救援",
      2: "/healthManager/list?aType=7&aTitle=健康体检",
      3: "/healthManager/list?aType=5&aTitle=认知症早筛",
      4: "/healthManager/list?aType=11&aTitle=法律咨询",
    };
    return pages[type] ?? "";
  },
};
